import React from "react";
import { createEmptyProjectStep } from "./factories";
import StepEditorCard from "./StepEditorCard";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import Button from "../../../../../../components/elements/Button";

export default function StepsEditor({ steps, path, updateAtPath }) {
    const canDeleteStep = (stepIndex) => steps.length > 1;

    const addStep = () => {
        const next = steps.concat([createEmptyProjectStep()]);
        updateAtPath(path, next);
    };

    const deleteStep = (stepIndex) => {
        if (!canDeleteStep(stepIndex)) {
            window.alert("You must have at least one step.");
            return;
        }
        const next = steps.filter((_, i) => i !== stepIndex);
        updateAtPath(path, next);
    };

    return (
        <div className='grid gap-10 mb-16'>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <h3 style={{ margin: 0 }}>Steps</h3>
                <Button onClick={addStep}>
                    <FontAwesomeIcon icon={faPlus} size={'lg'} />
                </Button>
            </div>

            {steps.map((step, stepIndex) => (
                <StepEditorCard
                    key={step.id || stepIndex}
                    step={step}
                    path={[...path, stepIndex]}
                    updateAtPath={updateAtPath}
                    onDelete={() => deleteStep(stepIndex)}
                    canDelete={canDeleteStep(stepIndex)}
                />
            ))}
        </div>
    );
}
